const CU = {
  countryConfig: {
    IBAN: {
      visible: false,
    },
    accountHolderDocNumber: {
      label: "bankDetails.idNumber",
      required: true,
    },
    accountNumber: {
      visible: true,
      required: true,
      label: "bankDetails.accountNumber",
    },
    swift: {
      visible: true,
      required: true,
      label: "bankDetails.swift",
    },
    bankAddress: {
      visible: false,
      required: false,
    },
  },
};
export { CU };
